import type { ProgressRowProps } from './types'
import { ProgressBar, ProgressContainer, ValueText } from './styles'
import { formatValue } from './utils'

export const ProgressRow = ({
  leftValue,
  leftFormat = 'decimal',
  leftColor,
  rightValue,
  rightFormat = 'decimal',
  rightColor,
  progressValue,
  progressColor,
  small = false
}: ProgressRowProps) => {
  return (
    <div>
      <ProgressContainer>
        <ValueText color={leftColor} small={small}>
          {formatValue(leftValue, leftFormat)}
        </ValueText>
        <ValueText color={rightColor} small={small}>
          {formatValue(rightValue, rightFormat)}
        </ValueText>
      </ProgressContainer>

      <ProgressBar
        small={small}
        progresscolor={progressColor}
        value={Math.min(100, progressValue)}
      />
    </div>
  )
}
